import { Component } from '@angular/core';

@Component({
  selector: 'app-ownership-conversion-portal',
  templateUrl: './ownership-conversion-portal.component.html',
  styleUrls: ['./ownership-conversion-portal.component.scss'],
  standalone: false,
})
export class OwnershipConversionPortalComponent {}
